import {APIService} from '@/services/api.service';
import {SolutionResponse} from '../solution/solution-support.types';

export function toggleFlightHotel(sessionId: string, flights: boolean, hotel: boolean) {
  return APIService.post<SolutionResponse>(
    `solution/display`,
    {},
    {
      params: {
        session_id: sessionId,
        display_flights: flights,
        display_accommodations: hotel,
      },
    },
  );
}
